export default "__VITE_ASSET__4f2d79db__"